export function generateString(length) {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function matchStringsWithoutCaseSensitivity(string1, string2) {
  if (!string1 || !string2) return false;
  return string1.toString().toUpperCase() === string2.toString().toUpperCase();
}
